<template>
    <div>
        <v-dialog
            v-model="isOpen"
            width="500"
            :persistent="true"
            v-if="type === 'risk'"
        >
            <v-card>
                <v-card-title>
                    <h4>
                        {{ name }}
                    </h4>
                </v-card-title>
                <div
                    style="
                        margin-bottom: 0;
                        margin-left: 25px;
                        font-size: 15px;
                        color: orange;
                    "
                >
                    <v-icon color="orange" size="20">mdi-alert</v-icon>
                    Select a rating below: 1 star = Least Risky, 5 stars = Most Risky.
                </div>

                <div style="display: flex; justify-content: center">
                    <v-rating
                        v-model="rating"
                        hover
                        length="5"
                        size="64"
                        background-color="grey"
                    ></v-rating>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        :disabled="loading"
                        @click="$emit('close')"
                        text
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        :loading="loading"
                        @click="updateRating('risk_rating')"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="isOpen"
            width="700"
            :persistent="true"
            v-if="type === 'time_decay'"
        >
            <v-card>
                <v-card-title>
                    <h4>
                        {{ name }}
                    </h4>
                </v-card-title>

                <EChartDisplay
                    :chartData="modalData['time_decay_chart'] || {}"
                    :chartType="
                        modalData['time_decay_chart']['chart_type'] || 'line'
                    "
                    :chartHeight="350"
                    chartName="Time Decay Chart"
                    :isOpen="isOpen"
                />

                <div
                    style="
                        margin-top: 20px;
                        margin-bottom: 0;
                        margin-left: 25px;
                        font-size: 15px;
                        color: orange;
                    "
                >
                    <v-icon color="orange" size="20">mdi-alert</v-icon>
                    Select a rating below: 1 star = Non-toxic, 2 stars =
                    Partially Toxic, 3 stars = Toxic.
                </div>

                <div style="display: flex; justify-content: center">
                    <v-rating
                        v-model="rating"
                        hover
                        length="3"
                        size="64"
                        background-color="grey"
                    />
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        :disabled="loading"
                        @click="$emit('close')"
                        text
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="green"
                        text
                        :loading="loading"
                        @click="updateRating('time_decay_rating')"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import EChartDisplay from "./EChartDisplay.vue";
import { changeAlertMessageRating } from "@services/alert-message";
import { snackbar } from "@components/mixins/snackbar";

export default {
    components: { EChartDisplay },
    props: {
        type: "",
        isOpen: false,
        modalData: {},
    },
    data: () => ({
        loading: false,
        name: "",
        rating: 0,
    }),
    mixins: [snackbar],
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.name =
                    this.type === "risk" ? "Risk Rating" : "Time Decay Rating";
                this.rating =
                    this.type === "risk"
                        ? this.modalData.risk_rating
                        : this.modalData.time_decay_rating;
            }
        },
    },
    methods: {
        updateRating(type) {
            const params = {
                id: this.modalData.id,
                rating_type: type,
                rating_level: this.rating,
            };
            this.loading = true;
            changeAlertMessageRating(params)
                .then(({ data }) => {
                    if (data === "Succeed") {
                        this.snackBarSuccess("Rating Update Succeeded.");
                        this.$emit("close", {
                            rating: this.rating,
                            type: type,
                        });
                    } else {
                        this.snackBarDanger(
                            "Rating Update Failed, please try again."
                        );
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
